var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgApple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0014 0C12.0479 0 12.0944 0 12.1436 0C12.2578 1.41044 11.7194 2.46432 11.0652 3.22751C10.4232 3.98542 9.54406 4.7205 8.1222 4.60897C8.02735 3.21872 8.56658 2.24301 9.21999 1.48158C9.82597 0.771967 10.9369 0.140517 12.0014 0Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.3053 14.6805C16.3053 14.6946 16.3053 14.7069 16.3053 14.7201C15.9057 15.9303 15.3357 16.9675 14.6401 17.93C14.0052 18.8038 13.2271 19.9798 11.8377 19.9798C10.6372 19.9798 9.83972 19.2078 8.60932 19.1868C7.30778 19.1657 6.59202 19.8323 5.40201 20C5.26588 20 5.12976 20 4.99627 20C4.12243 19.8735 3.4172 19.1815 2.90344 18.5579C1.38849 16.7154 0.217802 14.3354 0 11.2897C0 10.9911 0 10.6934 0 10.3948C0.0922145 8.21499 1.15136 6.44272 2.55917 5.58381C3.30216 5.12712 4.32354 4.73807 5.46085 4.91196C5.94827 4.98749 6.44623 5.15435 6.88271 5.31946C7.29636 5.47842 7.81364 5.76033 8.30369 5.7454C8.63566 5.73574 8.96588 5.56273 9.30049 5.44065C10.2806 5.08673 11.2414 4.68098 12.5078 4.87156C14.0298 5.10166 15.11 5.7779 15.7775 6.82124C14.49 7.64063 13.4721 8.87542 13.646 10.9841C13.8006 12.8995 14.9142 14.0201 16.3053 14.6805Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.5e9fe5f5d3900647378184609c5d5000.svg";
export { ForwardRef as ReactComponent };